export class SiterecordComment {
  id: string;
  comment: string;
  internal: boolean;
  creationDateTime: Date;
  creationUser: string;
}



// WEBPACK FOOTER //
// ./src/app/models/siterecord-comment.model.ts